import {useEffect, useState} from 'react';

import {fetchBraintreeData} from '@stubhub/payment-utils';

/**
 * This hooks initializes braintree and returns its client
 * @param {String} host the host to use in request
 * @param {String} currency currency to set in braintree
 * @param {String} country event country
 * @returns braintree client
 */
export const useBraintree = (host, currency, country) => {
  const [braintreeClient, setBraintreeClient] = useState(null);

  useEffect(() => {
    const inititializeBraintree = async () => {
      const {braintree, error} = (await fetchBraintreeData(host, currency, country)) || {};
      if (!error) {
        setBraintreeClient(braintree);
      }
    };

    if (currency && country) {
      inititializeBraintree();
    }
  }, [host, currency, country]);

  return braintreeClient;
};
